import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="234" height="333" version="1.1">
            <g transform="translate(0 -719.362)">
                <g fillOpacity="1">
                    <rect
                        width="233.244"
                        height="332.244"
                        x="0.378"
                        y="719.74"
                        fill="#fff"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0.756"
                        rx="8.919"
                        ry="8.946"
                    ></rect>
                    <path
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        d="M58.63 814.076l28.243-28.336-28.243-28.337-28.244 28.337z"
                    ></path>
                    <path
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        d="M58.63 1014.321l28.243-28.336-28.243-28.337-28.244 28.337z"
                    ></path>
                    <path
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        d="M58.63 914.199l28.243-28.337-28.243-28.336-28.244 28.336z"
                    ></path>
                    <path
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        d="M175.37 814.076l28.244-28.336-28.244-28.337-28.243 28.337z"
                    ></path>
                    <path
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        d="M175.37 1014.321l28.244-28.336-28.244-28.337-28.243 28.337z"
                    ></path>
                    <path
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        d="M175.37 914.199l28.244-28.337-28.244-28.336-28.243 28.336z"
                    ></path>
                    <path
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        d="M17.206 780.702l9.414-9.445-9.414-9.446-9.415 9.446z"
                    ></path>
                    <path
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        d="M216.794 991.022l9.415 9.446-9.415 9.445-9.414-9.445z"
                    ></path>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(.9903 1.0098)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M26.881 738.999q0 4.246-2.467 6.714-2.449 2.467-6.695 2.467-9.852 0-9.852-13.62 0-6.006 2.124-9.736 2.64-4.705 8.187-4.705 3.213 0 5.336 1.32 2.545 1.568 2.545 4.59 0 .67-.938.67h-2.83q-.555 0-.938-.631-.555-.938-.88-1.205-.784-.632-2.295-.632-2.544 0-3.96 2.372-1.11 1.913-1.243 4.706 2.238-1.78 5.356-1.78 3.96 0 6.312 2.794 2.238 2.64 2.238 6.676zm-4.992-.115q0-2.18-1.09-3.596-1.206-1.569-3.33-1.569-2.103 0-3.29 1.569-1.07 1.415-1.07 3.596 0 2.085 1.128 3.538 1.224 1.588 3.252 1.588 2.066 0 3.29-1.568 1.11-1.435 1.11-3.558z"
                            fontSize="39.175"
                        ></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="red"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(-.9903 -1.0098)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M-209.413-1015.527q0 4.246-2.467 6.714-2.449 2.467-6.695 2.467-9.851 0-9.851-13.62 0-6.005 2.123-9.736 2.64-4.705 8.187-4.705 3.213 0 5.337 1.32 2.544 1.568 2.544 4.59 0 .67-.937.67h-2.832q-.554 0-.937-.631-.555-.937-.88-1.205-.784-.632-2.295-.632-2.544 0-3.96 2.372-1.11 1.913-1.243 4.706 2.238-1.779 5.356-1.779 3.96 0 6.312 2.793 2.238 2.64 2.238 6.676zm-4.992-.115q0-2.18-1.09-3.596-1.206-1.569-3.329-1.569-2.104 0-3.29 1.569-1.071 1.415-1.071 3.596 0 2.085 1.128 3.539 1.225 1.587 3.252 1.587 2.066 0 3.29-1.568 1.11-1.435 1.11-3.558z"
                            fontSize="39.175"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default Icon;
